export enum UserRoles {
  LEAD_CREATE = "LEAD_CREATE",
  LEAD_DELETE = "LEAD_DELETE",
  LEAD_UPDATE = "LEAD_UPDATE",
  LEAD_VIEW = "LEAD_VIEW",
  CLIENT_CREATE = "CLIENT_CREATE",
  CLIENT_DELETE = "CLIENT_DELETE",
  CLIENT_UPDATE = "CLIENT_UPDATE",
  CLIENT_VIEW = "CLIENT_VIEW",
  CONTRACT_TYPE_CREATE = "CONTRACT_TYPE_CREATE",
  CONTRACT_TYPE_DELETE = "CONTRACT_TYPE_DELETE",
  CONTRACT_TYPE_UPDATE = "CONTRACT_TYPE_UPDATE",
  CONTRACT_TYPE_VIEW = "CONTRACT_TYPE_VIEW",
  CONTRACT_CREATE = "CONTRACT_CREATE",
  CONTRACT_DELETE = "CONTRACT_DELETE",
  CONTRACT_UPDATE = "CONTRACT_UPDATE",
  CONTRACT_VIEW = "CONTRACT_VIEW",
  DENIED_REASON_DELETE = "DENIED_REASON_DELETE",
  DENIED_REASON_UPDATE = "DENIED_REASON_UPDATE",
  DENIED_REASON_TYPE_CREATE = "DENIED_REASON_TYPE_CREATE",
  DENIED_REASON_TYPE_DELETE = "DENIED_REASON_TYPE_DELETE",
  DENIED_REASON_TYPE_UPDATE = "DENIED_REASON_TYPE_UPDATE",
  DENIED_REASON_TYPE_VIEW = "DENIED_REASON_TYPE_VIEW",
  INVENTORY_CREATE = "INVENTORY_CREATE",
  INVENTORY_DELETE = "INVENTORY_DELETE",
  INVENTORY_UPDATE = "INVENTORY_UPDATE",
  INVENTORY_VIEW = "INVENTORY_VIEW",
  INTEGRATION_VIEW = "INTEGRATION_VIEW",
  JOB_CREATE = "JOB_CREATE",
  JOB_DELETE = "JOB_DELETE",
  JOB_UPDATE = "JOB_UPDATE",
  JOB_VIEW = "JOB_VIEW",
  JOB_ZONE_CREATE = "JOB_ZONE_CREATE",
  JOB_ZONE_DELETE = "JOB_ZONE_DELETE",
  JOB_ZONE_UPDATE = "JOB_ZONE_UPDATE",
  JOB_ZONE_VIEW = "JOB_ZONE_VIEW",
  PAPER_PRODUCTS_CREATE = "PAPER_PRODUCTS_CREATE",
  PAPER_PRODUCTS_DELETE = "PAPER_PRODUCTS_DELETE",
  PAPER_PRODUCTS_UPDATE = "PAPER_PRODUCTS_UPDATE",
  PAPER_PRODUCTS_VIEW = "PAPER_PRODUCTS_VIEW",
  PROJECT_TYPE_CREATE = "PROJECT_TYPE_CREATE",
  PROJECT_TYPE_DELETE = "PROJECT_TYPE_DELETE",
  PROJECT_TYPE_UPDATE = "PROJECT_TYPE_UPDATE",
  PROJECT_TYPE_VIEW = "PROJECT_TYPE_VIEW",
  PROFILE_VIEW = "PROFILE_VIEW",
  SCOPE_OF_WORK_CREATE = "SCOPE_OF_WORK_CREATE",
  SCOPE_OF_WORK_DELETE = "SCOPE_OF_WORK_DELETE",
  SCOPE_OF_WORK_UPDATE = "SCOPE_OF_WORK_UPDATE",
  SCOPE_OF_WORK_VIEW = "SCOPE_OF_WORK_VIEW",
  SUPPLIES_CREATE = "SUPPLIES_CREATE",
  SUPPLIES_DELETE = "SUPPLIES_DELETE",
  SUPPLIES_UPDATE = "SUPPLIES_UPDATE",
  SUPPLIES_VIEW = "SUPPLIES_VIEW",
  TYPE_OF_FLOOR_SURFACES_CREATE = "TYPE_OF_FLOOR_SURFACES_CREATE",
  TYPE_OF_FLOOR_SURFACES_DELETE = "TYPE_OF_FLOOR_SURFACES_DELETE",
  TYPE_OF_FLOOR_SURFACES_UPDATE = "TYPE_OF_FLOOR_SURFACES_UPDATE",
  TYPE_OF_FLOOR_SURFACES_VIEW = "TYPE_OF_FLOOR_SURFACES_VIEW",
  USER_CREATE = "USER_CREATE",
  USER_DELETE = "USER_DELETE",
  USER_UPDATE = "USER_UPDATE",
  USER_VIEW = "USER_VIEW",
  SCHEDULE_TRACK = "SCHEDULE_TRACK",
  TIME_CARD_ACTIVITY_VIEW = "TIME_CARD_ACTIVITY_VIEW",
  TIME_CARD_VIEW = "TIME_CARD_VIEW",
  TIME_ANALYSIS_VIEW = "TIME_ANALYSIS_VIEW",
  ACTIVITY_DETAIL_VIEW = "ACTIVITY_DETAIL_VIEW",
  OVER_FORTY_HOURS_VIEW = "OVER_FORTY_HOURS_VIEW",
  LATE_VIEW = "LATE_VIEW",
  LATE_NO_SHOW_VIEW = "LATE_NO_SHOW_VIEW",
  ACTUAL_VS_SCHEDULED_VIEW = "ACTUAL_VS_SCHEDULED_VIEW",
  JOB_SUMMARY_VIEW = "JOB_SUMMARY_VIEW",
  ADD_ESTIMATE_REQUEST_CREATE = "ADD_ESTIMATE_REQUEST_CREATE",
  SEND_ESTIMATE_REQUEST_CREATE = "SEND_ESTIMATE_REQUEST_CREATE",
  WORKFORCE_DASHBOARD = "WORKFORCE_DASHBOARD",
  POWER_BI_VIEW = "POWER_BI_VIEW",
}
